// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 792 ? "main" : chunkId) + "." + {"792":"43071013","803":"25d357ca"}[chunkId] + ".css";
};